import { FunctionComponent } from 'react';
import {Card, Modal} from 'react-bootstrap';
import cn from 'classnames';
import styles from "./DeleteModal.module.css";
import CustomButton, { ButtonRadiusSize, ButtonType } from '../CustomButton/CustomButton';
interface IProps {
    showModal: boolean;
    title: string;
    bodyText: string | React.ReactNode | React.ReactElement;
    onClose: () => void;
    onDelete: () => void;
    className?: string;
};

const DeleteModal: FunctionComponent<IProps> = ({title, showModal, bodyText, onClose, onDelete, className}) => {
  return (
    <Modal 
        show={showModal} 
        className={cn(styles.deleteModal, className)}
        dialogClassName={styles.deleteModalDialog}
        contentClassName={styles.deleteModalContent}
        centered={true}
    >
        <Modal.Header bsPrefix={styles.header}>
          <Modal.Title bsPrefix={styles.title} as={'div'}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix={styles.body}>
            <Card.Text bsPrefix={styles.bodyText} as={'div'}>{bodyText}</Card.Text>
        </Modal.Body>
        <Modal.Footer bsPrefix={styles.footer}>
            <CustomButton
                className={styles.cancelBtn}
                btnType={ButtonType.LIGHTBLUE}
                btnRadius={ButtonRadiusSize.SMALL}
                onClick={onClose}
            >
                Cancel
            </CustomButton>
            <CustomButton
                className={styles.deleteBtn}
                btnType={ButtonType.RED}
                btnRadius={ButtonRadiusSize.SMALL}
                onClick={onDelete}
            >
                Delete
            </CustomButton>
        </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;